import React from 'react';
import moment from 'moment';

export const time = ({t, ...restProps}) => {
    return {
        Header: t('TagStateAlarmList;Time'),
        className: 'f-1 text-center',
        accessor: 'evtTime',
        headerClassName: 'f-1',
        Cell: ({ value }) => moment(value * 1000).format('HH:mm:ss'),
        ...restProps,
    };
};
export const targetName = ({t, ...restProps}) => {
    return {
        Header: t('TagStateAlarmList;Target name'),
        className: 'pr-3 pl-3 f-5 text-center text-ellipsis',
        accessor: 'targetName',
        headerClassName: 'f-5',
        ...restProps
    };
};
export const categoryName = ({t, ...restProps}) => {
    return {
        Header: t('TagStateAlarmList;Category name'),
        className: 'pr-3 pl-3 f-5 text-center',
        accessor: 'categoryName',
        headerClassName: 'f-5',
        ...restProps
    };
};
export const tagState = ({t, ...restProps}) => {
    return {
        Header: t('TagStateAlarmList;Tag state'),
        className: 'f-1 text-center',
        accessor: 'tagStateLabel',
        headerClassName: 'f-1',
        ...restProps
    };
};
export const patName = {
    Header: '이름',
    headerClassName: 'flex-center',
    accessor: 'patName',
    className: 'flex-center',
};
export const patAge = {
    Header: '나이',
    headerClassName: 'flex-center',
    accessor: 'patAge',
    className: 'flex-center',
};
export const respiratoryRate = {
    Header: '호흡 수',
    headerClassName: 'flex-center',
    accessor: 'respiratoryRate',
    className: 'flex-center',
};
export const temperature = {
    Header: '체온',
    headerClassName: 'flex-center',
    accessor: 'temperature',
    className: 'flex-center',
};
export const pulse = {
    Header: '맥박 수',
    headerClassName: 'flex-center',
    accessor: 'pulse',
    className: 'flex-center',
};
export const mmHg = {
    Header: '수축기 혈압 (mmHg)',
    headerClassName: 'flex-center',
    accessor: 'mmHg',
    className: 'flex-center',
};
export const oxygen = {
    Header: '산소 포화도',
    headerClassName: 'flex-center',
    accessor: 'oxygen',
    className: 'flex-center',
};
